mutation CreateKixieIntegration($input: KixieIntegrationCreateInput!) {
    kixieIntegrationCreate(input: $input) {
        kixieIntegration {
            isEnabledForUser
        }
    }
}
